import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";
// import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

export default function ChangeAdminPassword() {
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [disableBtn, setDisableBtn] = useState(false);
  //   const navigate = useNavigate(null);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.oldPassword === formData.newPassword) {
      toast.error("New Password should not be same as old password!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      toast.error("Passwords do not match!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    try {
      setDisableBtn(true);

      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const formdata = new FormData();
      formdata.append("oldPassword", formData.oldPassword);
      formdata.append("newPassword", formData.newPassword);
      formdata.append("confirmPassword", formData.confirmPassword);
      console.log("Headers: ", headers);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/change-password`,
        formData,
        {
          headers: headers,
        }
      );
      console.log("resposne", response);
      if (response.data.statusCode === 200) {
        toast.success("Password Changed successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setFormData({
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        // navigate("/admin-panel/dashboard");
      } else {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
    }
    setDisableBtn(false);
  };

  return (
    <Layout>
      <div>
        {/* Active Users */}
        <ToastContainer />
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">Change Password</h2>
          </div>
          <div className="w-full mt-10 text-center">
            <form action="" className="w-full" onSubmit={handleSubmit}>
              <div className="w-full mt-6">
                <input
                  type="oldPassword"
                  className="border border-[grey] rounded-md h-[46px] lg:w-1/2 w-full px-3 !outline-none text-sm"
                  placeholder="Enter Old Password Here..."
                  name="oldPassword"
                  value={formData.oldPassword}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="w-full mt-6">
                <input
                  type="newPassword"
                  className="border border-[grey] rounded-md h-[46px] lg:w-1/2 w-full px-3 !outline-none text-sm"
                  placeholder="Enter New Password Here..."
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="w-full mt-6">
                <input
                  type="confirmPassword"
                  className="border border-[grey] rounded-md h-[46px] lg:w-1/2 w-full px-3 !outline-none text-sm"
                  placeholder="Enter Confirm Password Here..."
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="mt-10">
                <button
                  type="submit"
                  className="rounded-md h-[46px] lg:w-1/2 w-full bg-[#2c2c38] text-white hover:bg-[#191919]"
                  disabled={disableBtn}
                >
                  {disableBtn ? "Please Wait ..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
}
